export default "__VITE_ASSET__zbYc82PB__"